export default __webpack_public_path__ + "static/media/hakerman.6a6c7cf2.gif";